import { COOKIE_CATEGORY } from 'enums/cmp'

export default {
  methods: {
    $_cmpEventsListener_dispatchUpdate(activeGroups) {
      this.$store.dispatch(`cmp/updateConsentActiveGroups`, activeGroups)
    },
    $_cmpEventsListener_setInstanceReady() {
      window.CmpWrapperReady = true
    },
    $_cmpEventsListener_onInstanceReady() {
      this.$_cmpEventsListener_setInstanceReady()
    },
    $_cmpEventsListener_initInstanceReady() {
      if (window.CookieScript?.instance) {
        this.$_cmpEventsListener_onInstanceReady()
      } else {
        window.addEventListener(
          'CookieScriptLoaded',
          this.$_cmpEventsListener_onInstanceReady
        )
      }
    },
    $_cmpEventsListener_onAcceptAll() {
      this.$_cmpEventsListener_dispatchUpdate(Object.values(COOKIE_CATEGORY))
    },
    $_cmpEventsListener_onRejectAll() {
      this.$_cmpEventsListener_dispatchUpdate([
        COOKIE_CATEGORY.STRICTLY_NECESSARY
      ])
    },
    $_cmpEventsListener_onAcceptSome(event) {
      const activeGroups = event.detail?.categories || []
      this.$_cmpEventsListener_dispatchUpdate(activeGroups)
    },
    $_cmpEventsListener_listenForConsentUpdates() {
      window.addEventListener(
        'CookieScriptAccept',
        this.$_cmpEventsListener_onAcceptSome
      )
      window.addEventListener(
        'CookieScriptAcceptAll',
        this.$_cmpEventsListener_onAcceptAll
      )
      window.addEventListener(
        'CookieScriptReject',
        this.$_cmpEventsListener_onRejectAll
      )
    }
  },
  mounted() {
    this.$_cmpEventsListener_initInstanceReady()
    this.$_cmpEventsListener_listenForConsentUpdates()
  },
  beforeDestroy() {
    window.removeEventListener(
      'CookieScriptAccept',
      this.$_cmpEventsListener_onAcceptSome
    )
    window.removeEventListener(
      'CookieScriptAcceptAll',
      this.$_cmpEventsListener_onAcceptAll
    )
    window.removeEventListener(
      'CookieScriptReject',
      this.$_cmpEventsListener_onRejectAll
    )
  }
}
